import React from 'react';
import { Table } from 'antd';
import { ColorRing } from 'react-loader-spinner';
import './style.scss';

const loaderIcon = <ColorRing height={60} width={60} />;

const TableComponent = ({ columns, dataSource, className = '', bordered = true, rowKey, title, pagination, footer, onChange, loading = false, ...rest }) => {
	return (
		<Table
			{...{
				loading: { indicator: loaderIcon, spinning: loading },
				className: `table-component ${className}`,
				// columns: loading
				// 	? columns.map((column) => {
				// 			return {
				// 				...column,
				// 				render: function renderPlaceholder() {
				// 					return <Skeleton key={column.dataIndex} title={true} active paragraph={false} style={{ width: '100%' }} />;
				// 				},
				// 			};
				// 	  })
				// 	: columns,
				columns,
				dataSource,
				bordered,
				rowKey,
				title,
				pagination,
				footer,
				onChange,
				...rest,
			}}
		/>
	);
};

export default TableComponent;
